import React from "react";
import style from "../../assets/css/admin/sideBar.module.css"
import "./SideBar.css"
import { Link } from "react-router-dom";


const SideBar = () => {
  return (
    <div className={`${style.sidebar}`}>
      <div className={`${style.adminTxtDiv}`}><h2 className={`${style.adminTxt}`}>Admin</h2></div>
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} ${style.accordionbody}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Dashboard
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <Link className="text-decoration-none" to={"/admin/dashboard"}>
                <ul className="sidebar-ul">
                  <li className="sidebar-li text-decoration-none">Dashboard</li>
                </ul>
              </Link>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Admins
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
                <Link className="text-decoration-none" to={"/admins"}>
                  <li className="sidebar-li text-decoration-none">All Admins</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/create"}>
                  <li className="sidebar-li text-decoration-none">Create Admin</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        {/* <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Exam Packages
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
                <Link className="text-decoration-none" to={"/admin/exam/package/create"}>
                  <li className="sidebar-li text-decoration-none">Add Exam Packages</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/exams/packages"}>
                  <li className="sidebar-li text-decoration-none">All Packages</li>
                </Link>
              </ul>
            </div>
          </div>
        </div> */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Exam
            </button>
          </h2>
          <div
            id="collapseFour"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
                <Link className="text-decoration-none" to={"/admin/exams/create"}>
                  <li className="sidebar-li text-decoration-none">Add Exam</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/exams"}>
                  <li className="sidebar-li text-decoration-none">All Exam</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse5"
              aria-expanded="false"
              aria-controls="collapse5"
            >
              Subject
            </button>
          </h2>
          <div
            id="collapse5"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
                <Link className="text-decoration-none" to={"/admin/subject/create"}>
                  <li className="sidebar-li text-decoration-none">Create Subject</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/subjects"}>
                  <li className="sidebar-li text-decoration-none">All Subject</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTopic"
              aria-expanded="false"
              aria-controls="collapseTopic"
            >
              Topic
            </button>
          </h2>
          <div
            id="collapseTopic"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
                <Link className="text-decoration-none" to={"/admin/topic/create"}>
                  <li className="sidebar-li text-decoration-none">Add Topic</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/topics"}>
                  <li className="sidebar-li text-decoration-none">All Topics</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse7"
              aria-expanded="false"
              aria-controls="collapse7"
            >
              Student
            </button>
          </h2>
          <div
            id="collapse7"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
                <Link className="text-decoration-none" to={"/admin/students"}>
                  <li className="sidebar-li text-decoration-none">All</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/students/view-details"}>
                  <li className="sidebar-li text-decoration-none">View details</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/student/register"}>
                  <li className="sidebar-li text-decoration-none">Add Student</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse8"
              aria-expanded="false"
              aria-controls="collapse8"
            >
              Q & A
            </button>
          </h2>
          <div
            id="collapse8"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
                <Link className="text-decoration-none" to={"/admin/questions/examwise"}>
                  <li className="sidebar-li text-decoration-none">Exam Wise</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/questions/topicwise"}>
                  <li className="sidebar-li text-decoration-none">Topic Wise</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/question/add"}>
                  <li className="sidebar-li text-decoration-none">Add</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse9"
              aria-expanded="false"
              aria-controls="collapse9"
            >
              Announcement
            </button>
          </h2>
          <div
            id="collapse9"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
              <Link className="text-decoration-none" to={"/admin/announcement/mail"}>
                  <li className="sidebar-li text-decoration-none">Exam Email</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/announcement/common-mail"}>
                  <li className="sidebar-li text-decoration-none">Common Email</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse10"
              aria-expanded="false"
              aria-controls="collapse10"
            >
              Courses
            </button>
          </h2>
          <div
            id="collapse10"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
              <Link className="text-decoration-none" to={"/admin/course/add"}>
                  <li className="sidebar-li text-decoration-none">Add Course</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/courses"}>
                  <li className="sidebar-li text-decoration-none">All Courses</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#material"
              aria-expanded="false"
              aria-controls="material"
            >
              Materials
            </button>
          </h2>
          <div
            id="material"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
              <Link className="text-decoration-none" to={"/admin/material/add"}>
                  <li className="sidebar-li text-decoration-none">Add Material</li>
                </Link>
                <Link className="text-decoration-none" to={"/admin/materials"}>
                  <li className="sidebar-li text-decoration-none">All</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="sidebarItem"><Link style={{width:'100%'}} to='/admin/blogs' className="sidebar-li text-decoration-none"><li style={{listStyle:'none'}} className="sidebar-li text-decoration-none">Blogs</li></Link></div>
        <div className="sidebarItem"><Link style={{width:'100%'}} to='/admin/testimonials' className="sidebar-li text-decoration-none"><li style={{listStyle:'none'}} className="sidebar-li text-decoration-none">Testimonials</li></Link></div>
        <div className="sidebarItem"><Link style={{width:'100%'}} to='/admin/gallery' className="sidebar-li text-decoration-none"><li style={{listStyle:'none'}} className="sidebar-li text-decoration-none">Gallery</li></Link></div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse12"
              aria-expanded="false"
              aria-controls="collapse12"
            >
              Payment
            </button>
          </h2>
          <div
            id="collapse12"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
              <Link className="text-decoration-none" to={"/admin/payment-details"}>
                  <li className="sidebar-li text-decoration-none">All</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button collapsed ${style.accordionbutton} `}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#inquiries"
              aria-expanded="false"
              aria-controls="inquiries"
            >
              Inquiries
            </button>
          </h2>
          <div
            id="inquiries"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <ul className="sidebar-ul">
              <Link className="text-decoration-none" to={"/admin/inquires"}>
                  <li className="sidebar-li text-decoration-none">All</li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
